import * as React from 'react';
import { Component } from '../../lib/component';
import { LoadingOverlay } from '../loading/overlay';
import {ImagePreloader} from '../../types/fn';
import {classes, style} from 'typestyle';
import {percent, px} from 'csx';
import {colorBackground, colorSlate, colorWhite} from '../../theme/color';
import {mediaMobileOnly} from '../../theme/media';
import {transitionQuickEase} from '../../theme/transition';
import {ResponsiveImage} from '../responsive-image';
import {centerCenter, centerJustified, horizontal, start, vertical} from 'csstips';
import {PageHeader} from '../page-header';

export interface ContentHeaderProps {
  className?: string;
  loading: boolean;
  imageIdentity: string;
  preload: ImagePreloader;
  noOverlay?: boolean;
}

export class ContentHeader extends Component<ContentHeaderProps> {
  render() {
    const { className, loading, imageIdentity, preload, noOverlay } = this.props;

    return (
      <div className={classes(ContentHeader.styles.container, loading && ContentHeader.styles.loading, className)}>
        <ResponsiveImage
          preload={preload}
          identity={imageIdentity}
          asBackground={true}
          wrapBackground={PageHeader.containerImage}
          className={ContentHeader.styles.coverImage}
        />
        <div className={ContentHeader.styles.content}>
          <div>
            {!loading && this.props.children}
          </div>
        </div>
        {!noOverlay && (
          <LoadingOverlay loading={loading} />
        )}
      </div>
    )
  }

  static styles = {
    container: style(
      {
        position: 'relative',
        width: percent(100),
        height: px(320),
        padding: 0,
        background: colorSlate.darken(0.075).toString(),
        $nest: {
          '& h1': {
            margin: 0,
            color: colorWhite.toString(),
            fontSize: px(60)
          },
          '& h2': {
            color: colorBackground.toString(),
            margin: 0,
            fontSize: px(32)
          }
        }
      },
      mediaMobileOnly({
        $nest: {
          '& h1': {
            margin: 0,
            fontSize: px(42)
          },
          '& h2': {
            margin: 0,
            fontSize: px(24)
          }
        }
      })
    ),
    loading: style({

    }),
    coverImage: style({
      transition: `opacity ${transitionQuickEase}`,
      zIndex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center'
    }),
    content: style(
      {
        ...horizontal,
        ...centerCenter,
        zIndex: 2,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        $nest: {
          '&>div': {
            ...vertical,
            ...start,
            ...centerJustified,
            position: 'relative',
            maxWidth: percent(100),
            width: percent(100),
            height: percent(100),
            padding: '0 80px 0',
          }
        }
      },
      mediaMobileOnly({
        $nest: {
          '&>div': {
            padding: '0 20px'
          }
        }
      })
    )
  }
}